import * as React from "react";
import * as Loadable from "react-loadable";

/** Parent nav items */
import * as ParentNavItems from "./Consts";

/** Presentation/UI */
import PageLoader from "../Components/PageLoader";

/** Containers */
import Dashboard from "../Containers/Dashboard";
import SignIn from "../Containers/Login";
import SignUp from "../Containers/SignUp";
import CompanySetup from "../Containers/CompanySetup";
import Team from "../Containers/Team";
import Companies from "../Containers/Companies";
import CompanyDetails from "../Containers/Consumer/CompanyDetails";
import UserSetup from "../Containers/UserSetup";
import Reports from "../Containers/Reports";
import AddReport from "../Containers/Reports/AddReport";
import Management from "../Containers/Management";
import ConsumerReports from "../Containers/ConsumerReports";
import Report from "../Containers/Report";
import Checkout from "../Containers/Checkout";
import PurchasedReports from "../Containers/PurchasedReports";
import AboutRoots from "../Containers/AboutRoots";
import Sales from "../Containers/Sales";

const AsyncDashboard = Loadable({
  loader: () => Promise.resolve(Dashboard),
  loading: () => <PageLoader />
});

const AsyncSignIn = Loadable({
  loader: () => Promise.resolve(SignIn),
  loading: () => <PageLoader />
});

const AsyncSignUp = Loadable({
  loader: () => Promise.resolve(SignUp),
  loading: () => <PageLoader />
});

const AsyncCompanySetup = Loadable({
  loader: () => Promise.resolve(CompanySetup),
  loading: () => <PageLoader />
});

const AsyncTeam = Loadable({
  loader: () => Promise.resolve(Team),
  loading: () => <PageLoader />
});

const AsyncCompanies = Loadable({
  loader: () => Promise.resolve(Companies),
  loading: () => <PageLoader />
});

const AsyncUserSetup = Loadable({
  loader: () => Promise.resolve(UserSetup),
  loading: () => <PageLoader />
});

const AsyncCompanyDetails = Loadable({
  loader: () => Promise.resolve(CompanyDetails),
  loading: () => <PageLoader />
});

const AsyncReportList = Loadable({
  loader: () => Promise.resolve(Reports),
  loading: () => <PageLoader />
});

const AsyncManagement = Loadable({
  loader: () => Promise.resolve(Management),
  loading: () => <PageLoader />
});

const AsyncAddReport = Loadable({
  loader: () => Promise.resolve(AddReport),
  loading: () => <PageLoader />
});
const AsyncConsumerReports = Loadable({
  loader: () => Promise.resolve(ConsumerReports),
  loading: () => <PageLoader />
});

const AsyncReport = Loadable({
  loader: () => Promise.resolve(Report),
  loading: () => <PageLoader />
});

const AsyncCheckout = Loadable({
  loader: () => Promise.resolve(Checkout),
  loading: () => <PageLoader />
});

const AsyncPurchasedReports = Loadable({
  loader: () => Promise.resolve(PurchasedReports),
  loading: () => <PageLoader />
});

const AsyncAboutRoots = Loadable({
  loader: () => Promise.resolve(AboutRoots),
  loading: () => <PageLoader />
});

const AsyncSales = Loadable({
  loader: () => Promise.resolve(Sales),
  loading: () => <PageLoader />
});

const routes = [
  {
    title: "Dashboard",
    path: "/dashboard",
    parent: ParentNavItems.DASHBOARD,
    component: AsyncDashboard,
    exact: true,
    private: true
  },
  {
    title: "Sign In",
    path: "/sign-in",
    component: AsyncSignIn,
    exact: true,
    private: false
  },
  {
    title: "Sign Up",
    path: "/sign-up",
    component: AsyncSignUp,
    exact: true,
    private: false
  },
  {
    title: "Company Setup",
    path: "/company-setup",
    component: AsyncCompanySetup,
    exact: true,
    private: false
  },
  {
    title: "Team",
    path: "/team",
    component: AsyncTeam,
    exact: true,
    private: true
  },
  {
    title: "Companies",
    path: "/admin/companies",
    component: AsyncCompanies,
    exact: true,
    private: true
  },
  {
    title: "User Setup",
    path: "/user-setup",
    component: AsyncUserSetup,
    exact: true,
    private: false
  },
  {
    title: "Sign In",
    path: "/",
    component: AsyncSignIn,
    exact: true,
    private: false
  },
  {
    title: "Team",
    path: "/admin/team",
    component: AsyncTeam,
    exact: true,
    private: true
  },
  {
    title: "Companies Team",
    path: "/companies/team",
    component: AsyncTeam,
    exact: true,
    private: true
  },
  {
    title: "Team",
    path: "/consumer/team",
    component: AsyncTeam,
    exact: true,
    private: true
  },
  {
    title: "Account",
    path: "/consumer/account",
    component: AsyncCompanyDetails,
    exact: true,
    private: true
  },
  {
    title: "Reports",
    path: "/admin-reports",
    component: AsyncReportList,
    exact: true,
    private: true
  },
  {
    title: "Add Report",
    path: "/admin-reports/add",
    component: AsyncAddReport,
    exact: true,
    private: true
  },
  {
    title: "Category",
    path: "/category-management",
    component: AsyncManagement,
    exact: true,
    private: true
  },
  {
    title: "Tags",
    path: "/tags-management",
    component: AsyncManagement,
    exact: true,
    private: true
  },
  {
    title: "Interest",
    path: "/interest-management",
    component: AsyncManagement,
    exact: true,
    private: true
  },
  {
    title: "Consumer Reports",
    path: "/consumer/reports",
    component: AsyncConsumerReports,
    exact: true,
    private: true
  },
  {
    title: "Report",
    path: "/consumer/report/:id",
    component: AsyncReport,
    exact: true,
    private: true
  },
  {
    title: "Checkout",
    path: "/consumer/checkout/:id",
    component: AsyncCheckout,
    exact: true,
    private: true
  },
  {
    title: "Purchased Reports",
    path: "/consumer/purchased",
    component: AsyncPurchasedReports,
    exact: true,
    private: true
  },
  {
    title: "About Roots",
    path: "/consumer/about-roots",
    component: AsyncAboutRoots,
    exact: true,
    private: true
  },
  {
    title: "Sales",
    path: "/admin/sales",
    component: AsyncSales,
    exact: true,
    private: true
  }
];

export default routes;



// WEBPACK FOOTER //
// ./src/Navigation/Routes.tsx